<app-contact-documents [contact]="contact"></app-contact-documents>
<app-contact-kine-treatment [contact]="contact"></app-contact-kine-treatment>
<app-contact-editor [contact]="contact"></app-contact-editor>